import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

export const LogoContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.logoContainer, style] });

const styles = StyleSheet.create({
  logoContainer: {
    justifyContent: 'center',
    marginRight: spacing.$0_5,
  },
});
